import Swiper from "swiper/bundle";
import "swiper/css/bundle";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.vacature_slider-layout").forEach((layout) => {
        const swiperEl = layout.querySelector(".vacature-swiper");
        if (!swiperEl) return;

        new Swiper(swiperEl, {
            loop: false,
            watchOverflow: true,
            navigation: {
                prevEl: layout.querySelector(".swiper-button-prev-custom"),
                nextEl: layout.querySelector(".swiper-button-next-custom"),
                disabledClass: "is-disabled",
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Vorige",
                nextSlideMessage: "Volgende",
                slideLabelMessage: "Slide {{index}} van {{slidesLength}}",
            },
            breakpoints: {
                0: { slidesPerView: 1.2, spaceBetween: 12 },
				560: { slidesPerView: 1.5, spaceBetween: 16 },
                640: { slidesPerView: 2.3, spaceBetween: 16 },
                993: { slidesPerView: 3, spaceBetween: 24 },
                1201: { slidesPerView: 4, spaceBetween: 24 },
            },
        });
    });
});
